import React from "react";
import { Form } from "react-bootstrap";
import Names from "./Names";
import SSN from "../form/SSN";

export default function TrusteeInformation(props) {
  return (
    <>
      <h5>Conservator Information</h5>
      <Names id="trustee" onChange={props.onChange} state={props.state} />
      <Form.Group controlId="trusteeTitle">
        <Form.Label>Title</Form.Label>
        <Form.Control
          required
          as="select"
          onChange={props.onChange}
          value={props.state.trusteeTitle}
        >
          <option value="">Please Select</option>
          <option value="trustee">Trustee</option>
          <option value="co-trustee">Co-trustee</option>
          <option value="successor trustee">Successor Trustee</option>
          <option value="executor">Executor</option>
          <option value="other">Other</option>
        </Form.Control>
        <Form.Control.Feedback type="invalid">
          Please select a valid title
        </Form.Control.Feedback>
      </Form.Group>
      <SSN
        id="trustee"
        state={props.state}
        onChange={props.onChange}
      />
    </>
  );
}
